import { useRouter } from 'next/router'
import { Layout } from '../components/common'
import { IGlobal } from '../interfaces'
import useTranslation from 'next-translate/useTranslation'
import { observer } from 'mobx-react-lite'
import MusicProgramForm from '../components/forms/MusicProgramForm'

const ReservationFormScreen = observer(
  ({ global: { navigation, activeFontFamily = 'body' } }: IGlobal) => {
    const { asPath } = useRouter()
    const { t } = useTranslation()

    return (
      <Layout
        title={`${t('common:ssmPageTitle')} | ${t('form:musicprogram.title')}`}
        path={asPath}
        navigation={navigation}
      >
        <MusicProgramForm activeFontFamily={activeFontFamily} />
      </Layout>
    )
  }
)
export default ReservationFormScreen
